const initialState = {
  year: 2018,
  photos: [],
};

export function pageReducer(state = initialState) {
  return state
}